
function DropDown(
  {
    options,
    value, 
    placeholder, 
    label, 
    maxRadioCount=5,
    onChange = ()=>{},
    method='GET',
    idProperty='id',
    nameProperty='name',
    ...props
}) {

  if (options.length === 0) {
    return <div className="text-muted"><label>{label}</label><span>No options available</span></div>;
  }

  if (options.length === 1) {
    if (value !== options[0][idProperty]) {
      onChange(options[0][idProperty]);
    }
    return <div><label>{label}</label> <span>{options[0][nameProperty]}</span></div>;
  }

  if (!options.map){
    console.error('DropDown options is not an array:', options);
    return <div className="text-danger">Error: Unable to show options</div>;
  }

  if (options.length <= maxRadioCount) {
    return <div>
      <h4>{label}</h4>
      <div className="radio-group">
      {options.map(option => (
          <label key={option[idProperty]} 
          className={"radio" + (value===option[idProperty] ? " selected" : "")} 
          onClick={()=>onChange(option[idProperty])}>{option[nameProperty]}</label>
      ))}
      </div>
    </div>;
  }

  return (
    <div className="mv-2">
      <select
        {...props}
        className="form-select"
        value={value}
        onChange={e => {
            if (onChange) {
              onChange(e.target.value);
            }   
        }}
      >
        <option value={undefined}>{placeholder || "-- Choose --"}</option>
        {options.map(option => (
          <option key={option[idProperty]} value={option[idProperty]}>
            {option[nameProperty]}
          </option>
        ))}
      </select>
    </div>
  );
}

export default DropDown;